export default function isValidContext(context) {
    return Boolean(context && ('nodeId' in context && context.nodeId !== undefined || 'syncBoxFilters' in context));
}
